"use strict";

require("./NoPermissionsController");